export enum FolderType {
    PARENT = "Überordner",
    FORMULAR = "Formular Ordner",
    LEISTUNG = "Leistungs Ordner", // In SuperAdmin equivalent to FORMULAR
    LEISTUNG_OHNE_PREISE = "Leistungs Ordner ohne Preise", // equivalent to LEISTUNG
    IMAGE = "Bilder Ordner",
    FREE = "Freier Ordner",
    DOCUMENTATION = "Dokumentations Ordner"
}
